module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-BoldItalic.6ba694a.woff2";